{
  "app.title": "eTTS — Test Token Server",
  "nav.dashboard": "Přehled",
  "nav.tokens": "Tokeny",
  "nav.logs": "Logy",
  "nav.transactionLogs": "Transakční logy",
  "nav.serverStats": "Statistiky serveru",
  "nav.settings": "Nastavení",
  "nav.docs": "Nápověda",
  "nav.signOut": "Odhlásit se",
  "header.settings": "Nastavení",
  "header.notifications": "Oznámení",
  "header.account": "Účet",
  "notifications.title": "Oznámení",
  "notifications.empty": "Žádná oznámení.",
  "theme.label": "Vzhled",
  "theme.system": "Systém",
  "theme.light": "Světlý",
  "theme.dark": "Tmavý",
  "theme.switchToDark": "Přepnout na tmavý motiv",
  "theme.switchToLight": "Přepnout na světlý motiv",
  "login.title": "Přihlášení",
  "login.subtitle": "Přihlaste se do administrace eTTS",
  "login.username": "Uživatelské jméno",
  "login.password": "Heslo",
  "login.submit": "Přihlásit se",
  "login.error": "Nesprávné jméno nebo heslo.",
  "login.loggedOut": "Byl jsi odhlášen.",
  "login.expired": "Vaše relace vypršela. Přihlaste se prosím znovu.",
  "dashboard.title": "Přehled",
  "dashboard.welcome": "Vítejte v eTTS administraci.",
  "dashboard.tokensTotal": "Tokeny celkem",
  "dashboard.tokensActive": "Aktivní",
  "dashboard.tokensDeleted": "Smazané",
  "dashboard.tokensActivating": "Aktivují se",
  "dashboard.tokensFailed": "Chybné",
  "dashboard.authServerDistribution": "Distribuce dle auth serveru",
  "dashboard.noData": "Žádná data",
  "dashboard.systemStats": "Systémové statistiky",
  "dashboard.systemStats.transactions": "Transakce celkem",
  "dashboard.systemStats.activationEvents": "Aktivační události",
  "dashboard.systemStats.commLogs": "Komunikační logy",
  "dashboard.quickActions": "Rychlé akce",
  "dashboard.quick.viewTokens": "Všechny tokeny",
  "dashboard.quick.testActivation": "Test aktivace",
  "dashboard.quick.apiDocs": "API dokumentace",
  "dashboard.quick.health": "Health check",
  "tokens.title": "Tokeny",
  "tokens.subtitle": "Seznam tokenů spravovaných tímto serverem.",
  "tokens.col.tokenId": "Token ID",
  "tokens.col.username": "Uživatel",
  "tokens.col.state": "Stav",
  "tokens.col.connector": "Konektor",
  "tokens.col.created": "Vytvořeno",
  "tokens.backToList": "Zpět na seznam",
  "tokens.field.licenceId": "Licence ID",
  "tokens.field.instanceSeq": "Instance",
  "tokens.field.activationGuid": "Aktivační GUID",
  "tokens.field.activated": "Aktivováno",
  "tokens.field.updated": "Aktualizováno",
  "tokens.field.activationEvents": "Aktivačních událostí",
  "tokens.field.keyStorageFormat": "Režim úložiště klíčů",
  "tokens.keyStorageFormat.ETTS": "ETTS",
  "tokens.keyStorageFormat.ETTS.hint": "levné odvození klíče z hesla — režim pro výkonnostní testy",
  "tokens.keyStorageFormat.SECURE": "SECURE",
  "tokens.keyStorageFormat.SECURE.hint": "Argon2id — plné šifrování úložiště, výrazně pomalejší aktivace",
  "tokens.keyStorageFormat.unrecorded": "nezaznamenáno — token vznikl dřív, než se režim ukládal",
  "tokens.field.expires": "Expirace",
  "tokens.field.tags": "Tagy",
  "tokens.connectorAttributes": "Atributy konektoru",
  "logs.title": "Logy",
  "logs.subtitle": "Komunikační logy auth serverů a aplikační log (auto-refresh 10 s).",
  "logs.tab.comm": "Komunikační",
  "logs.tab.app": "Aplikační",
  "logs.detailTitle": "Log #{{id}}",
  "logs.errorsOnly": "Jen chyby (4xx+5xx)",
  "logs.from": "Od",
  "logs.to": "Do",
  "logs.rowsShown": "zobrazeno",
  "logs.tokenId": "Token ID",
  "logs.statusFrom": "Status od",
  "logs.statusTo": "Status do",
  "logs.records": "Záznamů",
  "logs.headerFilters": "Filtr podle hlaviček",
  "logs.addHeader": "Přidat hlavičku",
  "logs.filter": "Filtrovat",
  "logs.reset": "Reset",
  "logs.autoRefresh": "Auto-refresh:",
  "logs.results": "výsledků",
  "logs.includeDetails": "Včetně detailů",
  "logs.page": "Stránka",
  "logs.total": "celkem",
  "logs.copy": "Kopírovat",
  "logs.col.server": "Server",
  "logs.col.token": "Token",
  "logs.app.lines": "Řádků",
  "logs.app.level": "Úroveň",
  "logs.app.filter": "Filtr",
  "logs.app.load": "Načíst",
  "logs.app.download": "Stáhnout",
  "logs.app.autoScroll": "Auto-scroll",
  "logs.app.lineCount": "{{count}} řádků (buffer {{max}})",
  "logs.copyCurl": "Kopírovat jako cURL",
  "logs.copyJson": "Kopírovat JSON",
  "logs.copied": "Zkopírováno",
  "logs.copyFail": "Kopírování selhalo",
  "logs.reqHeaders": "Request headers",
  "logs.reqBody": "Request body",
  "logs.resHeaders": "Response headers",
  "logs.resBody": "Response body",
  "logs.col.direction": "Směr",
  "logs.col.method": "Metoda",
  "logs.col.endpoint": "Endpoint",
  "logs.col.status": "Status",
  "logs.allLevels": "Vše",
  "logs.empty": "Žádné záznamy.",
  "txlogs.title": "Transakční logy",
  "txlogs.subtitle": "Audit schválení a zamítnutí transakcí.",
  "txlogs.col.created": "Čas",
  "txlogs.col.operation": "Operace",
  "txlogs.col.result": "Výsledek",
  "txlogs.col.duration": "Trvání",
  "txlogs.ok": "OK",
  "txlogs.fail": "Chyba",
  "pager.pageInfo": "Stránka {{page}} z {{pages}} · {{total}} záznamů",
  "pager.prev": "Předchozí",
  "pager.next": "Další",
  "txlogs.stat.total": "Operací celkem",
  "txlogs.stat.success": "Úspěšných",
  "txlogs.stat.last24h": "Za 24 h",
  "txlogs.stat.successRate": "Úspěšnost",
  "txlogs.stat.failed": "Neúspěšné",
  "txlogs.stat.approves": "Schválení",
  "txlogs.stat.rejects": "Zamítnutí",
  "txlogs.stat.avgDuration": "Prům. trvání",
  "txlogs.filter.from": "Od",
  "txlogs.filter.to": "Do",
  "pager.pageSize": "Velikost stránky",
  "txlogs.filter.autoRefresh": "Auto-refresh",
  "txlogs.filter.off": "Vypnuto",
  "txlogs.filter.live": "živě",
  "txlogs.col.txId": "Transaction ID",
  "pager.first": "První",
  "pager.last": "Poslední",
  "txlogs.field.authServerTxId": "Auth Server TX ID",
  "txlogs.field.paatProfile": "PAAT profil",
  "txlogs.field.deviceAuthType": "Device Auth Type",
  "txlogs.field.createdAt": "Vytvořeno",
  "txlogs.field.startedAt": "Zahájeno",
  "txlogs.field.completedAt": "Dokončeno",
  "txlogs.field.traceId": "Trace ID",
  "txlogs.field.errorCode": "Kód chyby",
  "txlogs.field.correlationId": "Correlation ID",
  "txlogs.field.requestIp": "Request IP",
  "txlogs.field.userAgent": "User-Agent",
  "txlogs.field.mobileSdkData": "Mobile SDK Data",
  "txlogs.field.scmsHash": "SCMS Hash",
  "txlogs.detailTitle": "Transakční log #{{id}}",
  "txlogs.field.transactionId": "Transaction ID",
  "txlogs.field.signature": "Podpis",
  "txlogs.field.signatureValue": "Hodnota podpisu",
  "txlogs.field.encryptedHash": "Hash šifrovaných dat",
  "txlogs.field.password": "Heslo",
  "txlogs.field.rejectionReason": "Důvod zamítnutí",
  "txlogs.field.wysiwyg": "WYSIWYS data",
  "txlogs.field.decrypted": "Dešifrovaná data",
  "stats.title": "Statistiky serveru",
  "stats.subtitle": "Živé metriky serveru (obnovováno každých 5 s).",
  "stats.rps": "Požadavků/s",
  "stats.lastUpdate": "Poslední aktualizace",
  "stats.manual": "Ručně",
  "stats.refreshNow": "Obnovit nyní",
  "stats.processCpu": "Process CPU",
  "stats.systemCpu": "System CPU",
  "stats.gcLastPause": "GC poslední pauza",
  "stats.totalReq": "celkem",
  "stats.errorRate": "Chybovost",
  "stats.heap": "Heap paměť",
  "stats.throughputHistory": "Historie throughputu",
  "stats.throughput": "Request throughput",
  "stats.last1m": "Za 1 min",
  "stats.last5m": "Za 5 min",
  "stats.last1h": "Za 1 h",
  "stats.latency": "Latency percentily",
  "stats.latencyTotal": "Celková latence",
  "stats.latencyConnector": "Latence konektoru",
  "stats.latencyProcessing": "Latence zpracování",
  "stats.minMaxAvg": "min / max / avg",
  "stats.errors": "Chybovost",
  "stats.recentErrors": "Poslední chyby",
  "stats.noErrors": "Žádné nedávné chyby.",
  "stats.dbPool": "Databázový pool",
  "stats.httpPool": "HTTP pool",
  "stats.jvm": "JVM",
  "stats.active": "Aktivní",
  "stats.idle": "Volné",
  "stats.waiting": "Čekající",
  "stats.utilization": "Využití",
  "stats.leased": "Zapůjčené",
  "stats.available": "Dostupné",
  "stats.pending": "Čekající",
  "stats.threads": "Vlákna",
  "stats.nonHeap": "Non-heap",
  "settings.title": "Nastavení",
  "settings.subtitle": "Konfigurace serveru, konektorů a přístupu",
  "settings.group.overview": "Přehled",
  "settings.group.system": "Systém",
  "settings.group.operations": "Provoz",
  "settings.group.access": "Přístup",
  "settings.group.appearance": "Vzhled",
  "settings.users": "Uživatelé",
  "settings.connectors": "Konektory",
  "settings.maintenance": "Údržba",
  "settings.general": "Obecné",
  "settings.audit": "Audit",
  "settings.tls": "TLS",
  "tls.title": "TLS",
  "tls.subtitle": "Stav TLS a operace (certifikát se mění env proměnnými)",
  "tls.status": "Stav",
  "tls.https": "HTTPS aktivní",
  "tls.plainHttp": "Plain HTTP",
  "tls.protocols": "Protokoly",
  "tls.listenPort": "Naslouchací port",
  "tls.httpPort": "HTTP port",
  "tls.httpsPublicPort": "Veřejný HTTPS port",
  "tls.allowHttp": "Povolit HTTP",
  "tls.redirectHttp": "HTTP→HTTPS redirect",
  "tls.forwardHeaders": "Forward headers",
  "tls.keystore": "Keystore",
  "tls.acmeDomains": "ACME domény",
  "tls.renewalDays": "Obnova (dní před expirací)",
  "tls.reload": "Reload bundle",
  "tls.renew": "Obnovit certifikát (ACME)",
  "tls.activeCert": "Aktivní certifikát",
  "tls.subject": "Subject",
  "tls.issuer": "Issuer",
  "tls.validity": "Platnost",
  "tls.serial": "Sériové číslo",
  "tls.fingerprint": "Fingerprint",
  "tls.history": "Historie certifikátů",
  "tls.installed": "Nainstalováno",
  "tls.expires": "Expirace",
  "tls.source": "Zdroj",
  "tls.activeCol": "Aktivní",
  "tls.notes": "Poznámky",
  "tls.enableHintTitle": "TLS není aktivní (běží plain HTTP)",
  "tls.enableHint": "Nastavte ETTS_TLS_SOURCE=keystore (přímé TLS) nebo terminujte TLS na reverzní proxy a nastavte SERVER_FORWARD_HEADERS_STRATEGY=framework. Viz env reference níže.",
  "audit.title": "Auth audit log",
  "audit.subtitle": "Přihlášení, správa uživatelů a bezpečnostní události",
  "audit.search": "Hledat",
  "audit.empty": "Žádné audit události",
  "audit.detailTitle": "Detail audit události",
  "audit.details": "Detaily",
  "audit.copy": "Kopírovat",
  "audit.time": "Čas",
  "audit.event": "Událost",
  "audit.eventGroups": "Skupiny",
  "audit.group.login": "Přihlášení",
  "audit.group.password": "Hesla",
  "audit.group.users": "Uživatelé",
  "audit.group.apiKeys": "API klíče",
  "audit.group.security": "Bezpečnost",
  "audit.outcome": "Výsledek",
  "audit.actor": "Aktér",
  "audit.ip": "IP adresa",
  "audit.target": "Cíl",
  "account.title": "Účet",
  "account.subtitle": "Váš profil a změna hesla",
  "account.username": "Uživatelské jméno",
  "account.displayName": "Zobrazované jméno",
  "account.email": "E-mail",
  "account.roles": "Role",
  "account.authSource": "Zdroj autentizace",
  "account.bootstrap": "Bootstrap admin",
  "account.mustChange": "Vynutit změnu hesla",
  "account.ldapNote": "Tento účet se ověřuje proti externímu adresáři (LDAP). Heslo změňte tam.",
  "account.changePassword": "Změna hesla",
  "account.locked.title": "Změna hesla je pro toto nasazení uzamčena",
  "account.locked.detail": "Funkce Správa uživatelů (admin.user-management) není povolena ve vašem licenčním tieru, takže je formulář změny hesla v aplikaci deaktivován.",
  "account.locked.bootstrapIntro": "Jste přihlášeni jako bootstrap admin. Rotace hesla tohoto účtu:",
  "account.locked.bootstrapStep1": "Změňte ETTS_INITIAL_ADMIN_PASSWORD ve svém prostředí.",
  "account.locked.bootstrapStep2": "Ujistěte se, že ETTS_BOOTSTRAP_SYNC_PWD=true (výchozí v docker-compose.yml).",
  "account.locked.bootstrapStep3": "Restartujte aplikaci — bootstrap admin heslo se při startu znovu synchronizuje.",
  "account.locked.nonbootstrap": "Požádejte administrátora se shell přístupem o rotaci hesla, nebo upgradujte licenci pro povolení správy uživatelů.",
  "account.advertised.title": "Samoobslužná změna hesla brzy dorazí",
  "account.advertised.detail": "Funkce Správa uživatelů je plánována pro budoucí vydání vašeho tieru. Do té doby heslo žije v bootstrap konfiguraci z prostředí; viz ETTS_INITIAL_ADMIN_PASSWORD.",
  "account.current": "Aktuální heslo",
  "account.new": "Nové heslo",
  "account.confirm": "Potvrdit heslo",
  "account.save": "Změnit heslo",
  "account.changed": "Heslo bylo změněno.",
  "account.mismatch": "Nové heslo a potvrzení se neshodují.",
  "account.tooShort": "Heslo musí mít alespoň 12 znaků.",
  "settings.tokenSettings": "Nastavení tokenů",
  "settings.uiSettings": "UI nastavení",
  "settings.appearance": "Vzhled",
  "appearance.title": "Vzhled",
  "appearance.subtitle": "Vyberte motiv aplikace. Motiv se ukládá do tohoto prohlížeče, jazyk k vašemu účtu.",
  "appearance.system": "Systém",
  "appearance.system.desc": "Podle nastavení systému",
  "appearance.light": "Světlý",
  "appearance.light.desc": "Vždy světlý motiv",
  "appearance.dark": "Tmavý",
  "appearance.dark.desc": "Vždy tmavý motiv",
  "common.confirm": "Potvrdit",
  "tokenSettings.title": "Nastavení tokenů",
  "tokenSettings.subtitle": "Režim instancí (jedna/více aktivních instancí na licenci)",
  "tokenSettings.currentMode": "Aktuální režim",
  "tokenSettings.buildProfile": "Build profil",
  "tokenSettings.default": "Výchozí",
  "tokenSettings.setSingle": "Přepnout na SINGLE",
  "tokenSettings.setMulti": "Přepnout na MULTI",
  "tokenSettings.switchTitle": "Změna režimu instancí",
  "tokenSettings.switchSingleWarn": "Přepnutí na SINGLE deaktivuje přebytečné aktivní instance na každé licenci. Pokračovat?",
  "tokenSettings.switchMultiInfo": "Přepnout na MULTI (více aktivních instancí na licenci)?",
  "tokenSettings.cleanupDone": "Deaktivováno {{tokens}} tokenů na {{licences}} licencích.",
  "uiSettings.title": "UI nastavení",
  "uiSettings.subtitle": "Viditelnost položek navigace",
  "uiSettings.saved": "Uloženo",
  "uiSettings.showAll": "Zobrazit vše",
  "uiSettings.hideAll": "Skrýt vše",
  "uiSettings.resetDefaults": "Obnovit výchozí",
  "general.title": "Obecné",
  "general.subtitle": "Runtime a HTTP klient (read-only)",
  "general.runtime": "Runtime",
  "general.httpClient": "HTTP klient",
  "general.noHttp": "Bez konfigurace",
  "general.envNote": "Konfigurace se mění env proměnnými při nasazení.",
  "general.activeGlobalTls": "Aktivní globální TLS verze",
  "general.poolMonitorNote": "HttpPoolMonitor loguje stav poolu každých 60 s; metriky jsou dostupné přes Prometheus (/actuator/prometheus).",
  "general.envReference": "Env proměnné connection-poolu",
  "general.env.poolMaxTotal": "Max. celkem poolovaných spojení",
  "general.env.poolMaxPerRoute": "Max. spojení na route",
  "general.env.connectTimeout": "Connect timeout (ms)",
  "general.env.readTimeout": "Read timeout (ms)",
  "general.env.tlsVersions": "Odchozí TLS verze",
  "tls.envReference": "TLS env proměnné",
  "tls.env.source": "Zdroj TLS (none / keystore / acme)",
  "tls.env.hsts": "Zapnout HSTS hlavičku",
  "tls.env.httpsPort": "Veřejný HTTPS port",
  "tls.env.allowHttp": "Povolit plain HTTP vedle HTTPS",
  "tls.env.forwardHeaders": "Strategie forwarded-headers (reverzní proxy)",
  "maintenance.title": "Údržba",
  "maintenance.subtitle": "Statistiky, úklid dat, zálohy a export/import tokenů",
  "maintenance.stats": "Statistiky databáze",
  "maintenance.refreshStats": "Obnovit statistiky",
  "maintenance.schedulers": "Automatické úlohy (schedulery)",
  "maintenance.autoCleanupScheduler": "Automatický úklid logů",
  "maintenance.tokenExpirationScheduler": "Expirace tokenů",
  "maintenance.enabled": "Zapnuto",
  "maintenance.retentionDays": "Retence (dny)",
  "maintenance.lastRun": "Poslední běh",
  "maintenance.httpLogs": "HTTP logy",
  "maintenance.txLogs": "Transakční logy",
  "maintenance.tokensTotal": "Tokeny celkem",
  "maintenance.tokensActive": "Aktivní tokeny",
  "maintenance.cleanupHttp": "Úklid HTTP komunikačních logů",
  "maintenance.cleanupTx": "Úklid transakčních logů",
  "maintenance.cleanupActivationEvents": "Úklid aktivačních událostí",
  "maintenance.cleanupTokens": "Úklid tokenů",
  "maintenance.olderThanDays": "Starší než (dní)",
  "maintenance.olderThanDaysOpt": "Starší než (dní, volitelné)",
  "maintenance.preview": "Náhled",
  "maintenance.delete": "Smazat",
  "maintenance.wouldDelete": "Ke smazání: {{count}} záznamů",
  "maintenance.deleted": "Smazáno: {{count}} záznamů",
  "maintenance.cleanupConfirm": "Smazat záznamy starší než {{days}} dní?",
  "maintenance.tokenCleanupConfirm": "Smazat tokeny ve stavech: {{states}}? Související transakce se smažou kaskádově.",
  "maintenance.backups": "Zálohy databáze",
  "maintenance.createBackup": "Vytvořit zálohu",
  "maintenance.noBackups": "Žádné zálohy",
  "maintenance.restore": "Obnovit",
  "maintenance.restoreConfirm": "Obnovit databázi ze zálohy {{filename}}? PŘEPÍŠE všechna aktuální data.",
  "maintenance.deleteBackupConfirm": "Smazat zálohu {{filename}}?",
  "maintenance.exportImport": "Export / Import tokenů",
  "maintenance.export": "Export",
  "maintenance.import": "Import",
  "maintenance.includePasswords": "Včetně hesel",
  "maintenance.activeCascadeWarning": "Mazání ACTIVE tokenů kaskáduje — související data se smažou. Nebezpečné!",
  "maintenance.includeActivationEvents": "Včetně aktivačních událostí",
  "maintenance.exportBtn": "Exportovat",
  "maintenance.overwrite": "Přepsat existující",
  "maintenance.importBtn": "Importovat",
  "maintenance.importPreview": "Celkem {{total}} · nových {{fresh}} · existujících {{existing}}",
  "maintenance.imported": "Aktualizováno {{updated}} · přeskočeno {{skipped}} · selhalo {{failed}}",
  "maintenance.dangerZone": "Nebezpečná zóna",
  "maintenance.fullReset": "Kompletní reset DB",
  "maintenance.fullResetDesc": "Smaže VŠECHNA data z databáze. Pouze pro vývoj/testování.",
  "maintenance.fullResetConfirm": "Opravdu smazat VŠECHNA data? Nevratné.",
  "maintenance.typeReset": "Pro potvrzení napiš RESET:",
  "connectors.title": "Konektory",
  "connectors.reset": "Reset",
  "connectors.resetConfirm": "Vrátit konektor {{type}} na výchozí konfiguraci? Přepíše aktuální nastavení.",
  "connectors.editHint": "Prázdné/maskované (****) hodnoty credentials se při uložení zachovají.",
  "connectors.enabledLabel": "Konektor povolen",
  "connectors.enable": "Povolit konektor",
  "connectors.disable": "Zakázat konektor",
  "connectors.credentials": "Přihlašovací údaje",
  "connectors.tabGeneral": "Obecné",
  "connectors.configJson": "Konfigurace (JSON)",
  "connectors.credsJson": "Credentials (JSON)",
  "connectors.credsHint": "Ponech **** nebo prázdné pro zachování stávajícího tajemství.",
  "connectors.invalidConfigJson": "Neplatný JSON v konfiguraci.",
  "connectors.invalidCredsJson": "Neplatný JSON v credentials.",
  "connectors.subtitle": "Stav a test připojení auth serverů.",
  "connectors.none": "Žádné konektory nejsou k dispozici.",
  "connectors.enabled": "Zapnutý",
  "connectors.disabled": "Vypnutý",
  "connectors.test": "Test připojení",
  "connectors.testing": "Testuji…",
  "connectors.enableFirst": "Nejprve povolte konektor",
  "connectors.config": "Konfigurace",
  "connectors.ok": "Připojení funguje",
  "connectors.fail": "Připojení selhalo",
  "connectors.route": "Trasa",
  "connectors.route.direct": "napřímo",
  "connectors.route.proxy": "přes proxy {{target}}",
  "connectors.degraded": "Odpověděl někdo jiný než cílový server",
  "connectors.detail.PROBE_ENDPOINT_UNAVAILABLE": "Brána odpověděla {{status}} — ověřovací endpoint v tomto prostředí není",
  "connectors.detail.REQUIRES_AUTHENTICATION": "Server odpověděl, endpoint vyžaduje přihlášení",
  "connectors.detail.NOT_FROM_TARGET_SERVER": "Odpověď nepřišla od cílového serveru — pravděpodobně ji vrátila proxy",
  "settings.apiKeys": "API klíče",
  "apikeys.title": "API klíče",
  "apikeys.subtitle": "API klienti a jejich klíče pro programový přístup.",
  "apikeys.usage.intro": "Klíč se posílá v hlavičce Authorization se schématem ApiKey:",
  "apikeys.usage.notBearer": "Schéma Bearer je vyhrazené pro JWT z /api/v1/auth/login — klíč poslaný jako Bearer vrátí 401 bez ohledu na role a scopes.",
  "apikeys.usage.help": "Podrobnosti v nápovědě",
  "apikeys.usage.modalHint": "Posílejte v hlavičce Authorization se schématem ApiKey (ne Bearer).",
  "apikeys.addClient": "Přidat klienta",
  "apikeys.noClients": "Žádní API klienti.",
  "apikeys.enabled": "Aktivní",
  "apikeys.disabled": "Neaktivní",
  "apikeys.addKey": "Nový klíč",
  "apikeys.noKeys": "Žádné klíče.",
  "apikeys.keys": "Klíče",
  "apikeys.label": "Popisek",
  "apikeys.scopes": "Scopes",
  "apikeys.roles": "Role",
  "apikeys.created": "Vytvořen",
  "apikeys.lastUsed": "Naposledy použit",
  "apikeys.revoked": "Odvolaný",
  "apikeys.active": "Aktivní",
  "apikeys.revoke": "Odvolat",
  "apikeys.name": "Název",
  "apikeys.description": "Popis",
  "apikeys.nameRequired": "Zadejte název.",
  "apikeys.newKey": "Nový API klíč",
  "apikeys.needScopeOrRole": "Vyberte alespoň jednu roli nebo scope.",
  "apikeys.ttl": "Platnost (dny)",
  "apikeys.ttlNever": "Bez expirace",
  "apikeys.generate": "Vygenerovat",
  "apikeys.copyNow": "Zkopírujte klíč teď — už se znovu nezobrazí.",
  "apikeys.copy": "Kopírovat",
  "apikeys.deleteClientTitle": "Smazat klienta",
  "apikeys.deleteClientConfirm": "Opravdu smazat klienta {{name}} včetně všech klíčů?",
  "common.delete": "Smazat",
  "common.done": "Hotovo",
  "settings.directory": "Directory (LDAP)",
  "directory.title": "Directory (LDAP)",
  "directory.subtitle": "Přehled adresářových providerů a test spojení.",
  "directory.none": "Žádný LDAP provider není nakonfigurován.",
  "directory.available": "Dostupný",
  "directory.unavailable": "Nedostupný",
  "directory.filter": "User filter",
  "directory.lastSuccess": "Poslední úspěch",
  "directory.lastFailure": "Poslední chyba",
  "directory.ok": "Spojení funguje",
  "directory.fail": "Spojení selhalo",
  "settings.license": "Licence",
  "license.title": "Licence",
  "license.subtitle": "Informace o licenci a aktivace klíče.",
  "license.customer": "Zákazník",
  "license.tier": "Tier",
  "license.status": "Stav",
  "license.valid": "Platná",
  "license.invalid": "Neplatná",
  "license.validFrom": "Platná od",
  "license.validTo": "Platná do",
  "license.modules": "Aktivní moduly",
  "license.features": "Funkce",
  "license.enabled": "aktivních",
  "license.advertised": "avizovaných",
  "license.locked": "zamčených",
  "license.featuresByModule": "Funkce podle modulu",
  "license.featuresCount": "funkcí",
  "license.plannedFeatures": "Plánované funkce",
  "license.runtimeExpiry": "Runtime aktivace do",
  "license.activate": "Aktivovat",
  "license.activateHint": "Vložte licenční klíč pro odemčení dalších modulů za běhu.",
  "license.keyRequired": "Zadejte licenční klíč.",
  "license.activated": "Licence aktivována.",
  "license.activateFailed": "Aktivace selhala.",
  "users.title": "Uživatelé",
  "users.subtitle": "Správa uživatelských účtů a rolí.",
  "users.add": "Přidat uživatele",
  "users.editTitle": "Upravit uživatele",
  "users.deleteTitle": "Smazat uživatele",
  "users.deleteConfirm": "Opravdu smazat uživatele {{username}}? Tuto akci nelze vzít zpět.",
  "users.resetPassword": "Změnit heslo",
  "users.newPassword": "Nové heslo",
  "users.edit": "Upravit",
  "users.delete": "Smazat",
  "users.enabled": "Aktivní",
  "users.disabled": "Deaktivní",
  "users.enabledLabel": "Účet aktivní",
  "users.pwMin": "Heslo musí mít alespoň 12 znaků.",
  "users.rolesMin": "Vyberte alespoň jednu roli.",
  "users.col.username": "Uživatelské jméno",
  "users.col.displayName": "Zobrazované jméno",
  "users.col.roles": "Role",
  "users.role.admin.desc": "Plný přístup — správa uživatelů, konektorů, tokenů i nastavení.",
  "users.role.operator.desc": "Provozní operace nad tokeny a transakcemi bez správy uživatelů.",
  "users.role.viewer.desc": "Jen pro čtení — přehledy, logy a statistiky.",
  "users.roles.hint": "Každá role se rozbaluje do více oprávnění (scopes).",
  "users.col.status": "Stav",
  "users.col.source": "Zdroj",
  "users.col.lockedUntil": "Uzamčeno do",
  "users.authSource": "Zdroj autentizace",
  "users.externalId": "Externí identifikátor",
  "users.extIdRequired": "Externí identifikátor je povinný pro LDAP.",
  "users.changeAuthSource": "Změnit zdroj autentizace",
  "users.newPasswordOptional": "Nové heslo (volitelné)",
  "users.recentAudit": "Nedávný auth audit",
  "users.recentAudit.showAll": "Zobrazit celý audit",
  "users.col.lastLogin": "Poslední přihlášení",
  "common.cancel": "Zrušit",
  "common.save": "Uložit",
  "common.loading": "Načítám…",
  "common.loadError": "Nepodařilo se načíst data.",
  "testing.title": "Testovací nástroje",
  "testing.subtitle": "Interaktivní nástroje pro ověření integrace s auth servery",
  "testing.activation": "Aktivace",
  "testing.activation.title": "Test aktivace tokenu",
  "testing.activation.subtitle": "Interaktivní nástroj s živým sledováním průběhu",
  "testing.activation.params": "Parametry testu",
  "testing.activation.noAuthServers": "Žádný podporovaný konektor není aktivní",
  "testing.activation.start": "Spustit test",
  "testing.activation.success": "Aktivace úspěšná",
  "testing.activation.failed": "Aktivace selhala",
  "testing.field.authServer": "Typ auth serveru",
  "testing.field.username": "Uživatelské jméno",
  "testing.field.otp": "OTP",
  "testing.field.password": "Heslo",
  "testing.field.activationGuid": "Aktivační GUID",
  "testing.field.expiresInSeconds": "Platnost (s)",
  "testing.field.expiresInSeconds.placeholder": "bez expirace",
  "testing.field.tags": "Tagy",
  "testing.field.tags.placeholder": "oddělené čárkou, např. smoke, zatez",
  "testing.field.pushIdentifier": "Push identifikátor (FCM token)",
  "testing.field.applicationId": "Application ID",
  "testing.field.deviceType": "Device Type",
  "testing.field.deviceType.hint": "Volitelné — výchozí 34. Nastav jen při testování alternativních kódů zařízení.",
  "testing.field.paatProfile": "PAAT profil (info o zařízení)",
  "testing.field.paatProfile.default": "-- Použít výchozí profil --",
  "testing.field.guidOptional": "Aktivační GUID (volitelné)",
  "testing.generate": "Generovat",
  "testing.running": "Probíhá…",
  "testing.connectorSpecific": "Specifické pro konektor",
  "testing.progress": "Průběh testu",
  "testing.httpCalls": "HTTP volání",
  "testing.httpLog": "HTTP komunikační log",
  "testing.viewToken": "Zobrazit detail tokenu",
  "testing.runAnother": "Spustit další test",
  "testing.exportJson": "Export (JSON)",
  "testing.exportCsv": "Export (CSV)",
  "testing.validation.required": "Vyplňte prosím všechna povinná pole",
  "testing.validation.appIdRequired": "Application ID je povinné pro eCobra",
  "testing.validate.title": "Ověřit aktivaci (získat Bearer token)",
  "testing.validate.submit": "Ověřit a získat token",
  "testing.validate.running": "Ověřuji…",
  "testing.validate.success": "Ověření úspěšné",
  "testing.validate.failed": "Ověření selhalo",
  "testing.validate.copyFromMain": "Zkopírovat z hlavního formuláře",
  "testing.validate.copyToken": "Kopírovat token",
  "testing.otp": "OTP / heslo",
  "testing.otp.title": "Test OTP a správy hesla",
  "testing.otp.subtitle": "Generování OTP, změna hesla a ověření OTP se živým průběhem",
  "testing.otp.scenario": "Scénář (předvyplnění)",
  "testing.otp.scenarioNone": "-- Vyberte scénář --",
  "testing.otp.mode": "Režim testu",
  "testing.otp.mode.OTP_GENERATION": "Generování OTP",
  "testing.otp.mode.PASSWORD_CHANGE": "Změna hesla",
  "testing.otp.mode.OTP_VERIFY": "Ověření OTP",
  "testing.otp.tokenId": "Token ID",
  "testing.otp.tokenRequired": "Token ID je povinné",
  "testing.otp.currentPassword": "Aktuální heslo",
  "testing.otp.currentPwRequired": "Aktuální heslo je povinné pro generování OTP",
  "testing.otp.oldPassword": "Staré heslo",
  "testing.otp.newPassword": "Nové heslo",
  "testing.otp.oldNewPwRequired": "Staré i nové heslo jsou povinná",
  "testing.otp.newPwMin": "Nové heslo musí mít alespoň 4 znaky",
  "testing.otp.otpCode": "OTP kód",
  "testing.otp.otpRequired": "OTP kód je povinný pro ověření",
  "testing.otp.start": "Spustit test",
  "testing.otp.success": "Test úspěšný",
  "testing.otp.failed": "Test selhal",
  "testing.otp.generatedOtp": "Vygenerované OTP",
  "testing.otp.expiresAt": "Platné do",
  "testing.otp.passwordChanged": "Heslo změněno",
  "testing.otp.otpValid": "OTP platné",
  "testing.otp.help.generation": "Vygeneruje nový OTP kód pro token (vyžaduje aktuální heslo)",
  "testing.otp.help.passwordChange": "Změní heslo tokenu (vyžaduje staré a nové heslo)",
  "testing.otp.help.verify": "Ověří OTP kód na auth serveru (eCobra nebo CSOB eChannels)",
  "testing.duration": "Doba trvání",
  "testing.completedAt": "Dokončeno",
  "common.yes": "Ano",
  "common.no": "Ne",
  "testing.dr": "Výměna zařízení",
  "testing.dr.title": "Test výměny zařízení",
  "testing.dr.subtitle": "Workflow create → process (QR sekvence) → complete se živým průběhem",
  "testing.dr.scenario": "Scénář (předvyplnění)",
  "testing.dr.scenarioNone": "-- Vyberte scénář --",
  "testing.dr.tokenId": "Token ID",
  "testing.dr.tokenRequired": "Token ID je povinné",
  "testing.dr.message": "Zpráva (volitelné)",
  "testing.dr.autoProcess": "Automaticky zpracovat po vytvoření",
  "testing.dr.autoComplete": "Auto-complete (vyžaduje nový aktivační GUID)",
  "testing.dr.simulateQrDelay": "Simulovat prodlevu skenování QR",
  "testing.dr.qrDelayMs": "Prodleva (ms)",
  "testing.dr.start": "Spustit test",
  "testing.dr.qrCodes": "QR sekvence",
  "testing.dr.qrSequence": "Sekvence {{index}} z {{total}}",
  "testing.dr.qrHelp": "Toto by se na původním zařízení zobrazilo jako QR kód",
  "testing.dr.success": "Test výměny zařízení úspěšný",
  "testing.dr.completedWarn": "Dokončeno s upozorněními",
  "testing.dr.failed": "Test selhal",
  "testing.dr.errorType": "Typ chyby",
  "testing.dr.stepsBeforeFailure": "Kroky dokončené před selháním",
  "testing.dr.originalTokenId": "Původní Token ID",
  "testing.dr.transactionId": "ID transakce",
  "testing.dr.qrSequenceCount": "Počet QR sekvencí",
  "testing.dr.newActivationGuid": "Nový aktivační GUID",
  "testing.dr.newTokenId": "Nový Token ID",
  "testing.dr.stepsExecuted": "Provedené kroky",
  "testing.dr.viewOriginal": "Detail původního tokenu",
  "testing.dr.viewNew": "Detail nového tokenu",
  "testing.admin": "Admin operace",
  "testing.admin.title": "Test admin operací",
  "testing.admin.subtitle": "Vyhledávání, hromadná deaktivace, health check a log operace",
  "testing.admin.scenario": "Scénář (předvyplnění)",
  "testing.admin.scenarioNone": "-- Vyberte scénář --",
  "testing.admin.mode": "Režim testu",
  "testing.admin.mode.TOKEN_SEARCH": "Vyhledání tokenů",
  "testing.admin.mode.BULK_DEACTIVATE": "Hromadná deaktivace",
  "testing.admin.mode.HEALTH_CHECK": "Health check",
  "testing.admin.mode.LOG_EXPORT": "Export logů",
  "testing.admin.mode.LOG_STATISTICS": "Statistiky logů",
  "testing.admin.mode.LOG_CLEANUP": "Čištění logů",
  "testing.admin.help.search": "Vyhledá tokeny podle filtrů (jméno, stav, typ auth serveru)",
  "testing.admin.help.bulk": "Deaktivuje více tokenů najednou — DESTRUKTIVNÍ operace",
  "testing.admin.help.health": "Zkontroluje stav databáze a všech auth serverů",
  "testing.admin.help.export": "Exportuje komunikační logy do JSON nebo CSV",
  "testing.admin.help.stats": "Spočítá statistiky komunikačních logů",
  "testing.admin.help.cleanup": "Smaže staré logy (s volitelným dry-run)",
  "testing.admin.any": "-- Vše --",
  "testing.admin.usernameFilter": "Filtr uživatelského jména",
  "testing.admin.stateFilter": "Filtr stavu",
  "testing.admin.authServerFilter": "Filtr typu auth serveru",
  "testing.admin.maxResults": "Max výsledků",
  "testing.admin.tokenIds": "Token ID (oddělené čárkou)",
  "testing.admin.tokenIdsHint": "Např. ECT0000000001-1, ECT0000000002-1",
  "testing.admin.tokenIdsRequired": "Zadejte alespoň jedno Token ID",
  "testing.admin.deactivationReason": "Důvod deaktivace",
  "testing.admin.bypassAuthServer": "Obejít auth server (jen lokální deaktivace)",
  "testing.admin.bulkConfirm": "Potvrzuji hromadnou deaktivaci uvedených tokenů",
  "testing.admin.bulkConfirmRequired": "Potvrďte hromadnou deaktivaci zaškrtnutím",
  "testing.admin.exportFormat": "Formát exportu",
  "testing.admin.daysToExport": "Počet dní",
  "testing.admin.statisticsDays": "Období (dní)",
  "testing.admin.retentionDays": "Retence (dní)",
  "testing.admin.dryRun": "Dry run (jen simulace, nemaže)",
  "testing.admin.dryRunLabel": "DRY RUN",
  "testing.admin.start": "Spustit test",
  "testing.admin.success": "Test úspěšný",
  "testing.admin.failed": "Test selhal",
  "testing.admin.totalMatches": "Počet shod",
  "testing.admin.deactivated": "Deaktivováno",
  "testing.admin.failedCount": "Selhalo",
  "testing.admin.errors": "Chyby",
  "testing.admin.healthStatus": "Celkový stav",
  "testing.admin.database": "Databáze",
  "testing.admin.activeTokens": "Aktivní tokeny",
  "testing.admin.exportedLogs": "Exportováno logů",
  "testing.admin.exportSize": "Velikost",
  "testing.admin.totalLogs": "Celkem logů",
  "testing.admin.errors24h": "Chyby (24 h)",
  "testing.admin.errorRate": "Chybovost",
  "testing.admin.deletedLogs": "Smazáno logů",
  "testing.admin.authServer": "Auth server",
  "testing.admin.requests": "Požadavky",
  "testing.admin.avgResponse": "Prům. odezva",
  "apitools.nav": "API Tools",
  "apitools.title": "API Tools",
  "apitools.subtitle": "Interaktivní REST request builder proti eTTS a konektorům",
  "apitools.execute": "Spustit",
  "apitools.executeHint": "Vyberte operaci a spusťte pro zobrazení odpovědi",
  "apitools.includeStats": "Zahrnout statistiky (X-API-Stats)",
  "apitools.required": "Pole „{{field}}\" je povinné",
  "apitools.requiredOneOf": "Vyplňte alespoň jedno z polí: {{fields}}",
  "apitools.success": "Úspěch",
  "apitools.error": "Chyba",
  "apitools.response": "Odpověď",
  "apitools.requestHeaders": "Hlavičky requestu",
  "apitools.requestBody": "Tělo requestu",
  "apitools.selectToken": "-- Vyberte token --",
  "apitools.selectAuthServer": "-- Vyberte auth server --",
  "apitools.any": "-- Vše --",
  "apitools.validPin": "Platný PIN",
  "apitools.invalidPin": "Neplatný PIN",
  "apitools.authorization": "Autorizace",
  "apitools.auth.none": "Žádná (anonymní)",
  "apitools.auth.adminJwt": "Můj admin JWT (cookie)",
  "apitools.auth.apikey": "API klíč",
  "apitools.auth.bearer": "Bearer token",
  "apitools.auth.customRaw": "Vlastní (verbatim)",
  "apitools.customHeaders": "Vlastní hlavičky",
  "apitools.headerName": "Název hlavičky",
  "apitools.headerValue": "Hodnota",
  "apitools.addHeader": "Přidat hlavičku",
  "apitools.attrKey": "klíč (např. applicationId)",
  "apitools.attrValue": "hodnota",
  "apitools.addAttr": "Přidat atribut",
  "apitools.sessionStale.title": "Relace vypršela",
  "apitools.sessionStale.body": "Request byl odmítnut bezpečnostní vrstvou (typicky zastaralý CSRF token po restartu). Obnovte stránku (Ctrl+Shift+R) a zkuste znovu.",
  "apitools.stats.total": "Celkem",
  "apitools.stats.connector": "Konektor",
  "apitools.stats.processing": "Zpracování",
  "apitools.stats.calls": "API volání",
  "apitools.stats.connectorCalls": "Volání konektoru (detail)",
  "apitools.genValidOtp": "Generovat platný OTP",
  "apitools.genInvalidOtp": "Generovat neplatný OTP",
  "apitools.op.activateToken": "Aktivovat token",
  "apitools.op.listTokens": "Seznam tokenů",
  "apitools.op.getToken": "Detail tokenu",
  "apitools.op.instanceInfo": "Stav tokenu",
  "apitools.f.syncState": "Uložit zjištěný stav do tokenu",
  "apitools.f.syncState.hint": "Bez zaškrtnutí se stav jen přečte z auth serveru (GET /api/v1/tokens/{id}/instance-info). Se zaškrtnutím se navíc uloží do tokenu (POST /admin/api/v1/tokens/{id}/sync-state) a odpověď ukáže původní i nový stav.",
  "apitools.op.deactivateToken": "Deaktivovat token",
  "apitools.op.generateOtp": "Generovat OTP",
  "apitools.op.verifyOtp": "Ověřit OTP",
  "apitools.f.authServerType": "Typ auth serveru",
  "apitools.f.username": "Uživatelské jméno",
  "apitools.f.otp": "OTP",
  "apitools.f.password": "Heslo",
  "apitools.f.activationGuid": "Aktivační GUID",
  "apitools.f.paatProfile": "PAAT profil",
  "apitools.f.testTraceId": "Test Trace ID",
  "apitools.f.expiresInSeconds": "Platnost (s)",
  "apitools.f.expiresInSeconds.hint": "Volitelné TTL tokenu v sekundách",
  "apitools.f.tags": "Tagy",
  "apitools.f.tags.hint": "Oddělené čárkou",
  "apitools.f.connectorAttributes": "Atributy konektoru",
  "apitools.generate": "Generovat",
  "apitools.f.pushIdentifier": "Push Identifier",
  "apitools.f.applicationId": "Application ID",
  "apitools.f.isMigration": "Migrace",
  "apitools.f.deviceType": "Device Type",
  "apitools.f.activationMethod": "Metoda aktivace",
  "apitools.f.appType": "App Type",
  "apitools.f.applicationName": "Application Name",
  "apitools.f.kbId": "KBID (identifikátor klienta)",
  "apitools.f.kbId.hint": "Vyplňte, jen když uživatelské jméno není KBID — ověřovací OTP se hledá podle KBID",
  "apitools.f.sourceTokenId": "Zdrojový token",
  "apitools.f.accessToken": "Access Token (override)",
  "apitools.f.accessToken.hint": "Prázdné = použít token uložený u zdrojového tokenu",
  "apitools.f.codeVerifier": "Code Verifier (override)",
  "apitools.f.codeVerifier.hint": "Prázdné = použít PKCE verifier zdrojového tokenu",
  "apitools.f.state": "Stav",
  "apitools.f.tag": "Tag",
  "apitools.f.tokenId": "Token",
  "apitools.group.token": "Tokeny",
  "apitools.group.tx": "Transakce",
  "apitools.group.dr": "Výměna zařízení",
  "apitools.op.pendingTransactions": "Čekající transakce",
  "apitools.op.transactionDetail": "Detail transakce",
  "apitools.op.approveTransaction": "Schválit transakci",
  "apitools.op.rejectTransaction": "Zamítnout transakci",
  "apitools.op.createDeviceReplacement": "Vytvořit výměnu",
  "apitools.op.processDeviceReplacement": "Zpracovat výměnu",
  "apitools.op.verifyActivation": "Ověřit aktivaci",
  "apitools.op.assembleSequences": "Sestavit sekvence",
  "apitools.f.ippids": "IPPIDs",
  "apitools.f.ippids.hint": "Prázdné = auto z username tokenu",
  "apitools.f.status": "Stav",
  "apitools.f.status.all": "0 — vše",
  "apitools.f.transactionId": "ID transakce",
  "apitools.f.transactionId.hint": "GUID pro eChannels, operationId pro eCobra",
  "apitools.f.limit": "Limit",
  "apitools.f.includeDetails": "Včetně detailů",
  "apitools.f.secureMessage": "Secure Message",
  "apitools.f.secureMessage.hint": "Base64 podepisovaná data",
  "apitools.f.passwordType": "Typ hesla (podpis)",
  "apitools.f.recognitionType": "Recognition Type",
  "apitools.f.mode": "Režim",
  "apitools.f.reason": "Důvod",
  "apitools.f.sequences": "Sekvence (JSON pole)",
  "apitools.f.sequences.hint": "JSON pole QR sekvencí",
  "apitools.invalidJsonArray": "Neplatné JSON pole (musí být neprázdné)",
  "apitools.dr.nextStep": "Další krok:",
  "apitools.dr.approve": "Schválit",
  "apitools.dr.reject": "Zamítnout",
  "apitools.dr.fillVerify": "Předvyplnit Ověřit aktivaci",
  "apitools.dr.fillAssemble": "Předvyplnit Sestavit sekvence",
  "apitools.group.kbcaas": "KB CAAS",
  "apitools.op.kbCaasGetInstanceInfo": "Info o instanci",
  "apitools.op.kbCaasEvaluateDevice": "Evaluate Device",
  "apitools.op.kbCaasInitContext": "Init Context",
  "apitools.op.kbCaasDictionaryLatest": "Slovník — poslední verze",
  "apitools.op.kbCaasGetDictionary": "Slovník — verze",
  "apitools.f.version": "Verze",
  "apitools.dict.title": "Lokální cache slovníků",
  "apitools.dict.refresh": "Obnovit",
  "apitools.dict.empty": "Žádné uložené slovníky",
  "apitools.dict.version": "Verze",
  "apitools.dict.fetchedAt": "Staženo",
  "apitools.dict.size": "Velikost",
  "apitools.dict.view": "Zobrazit",
  "apitools.group.privat": "Privat banka",
  "apitools.op.privatLogin": "Přihlášení (získat Bearer token)",
  "apitools.op.privatInvalidateLogin": "Zahodit uložený token",
  "apitools.f.forceLogin": "Vynutit nové přihlášení",
  "apitools.f.forceLogin.hint": "Ignoruje token uložený v paměti a projde oba kroky znovu.",
  "apitools.privatToken.title": "Bearer token pro Privat Mobile API",
  "apitools.privatToken.hint": "Bez access tokenu neprojde žádné volání na jejich API. Server si ho pro nástroje v administraci obstarává sám; tady je vidět, jestli nějaký drží, a dá se získat ručně.",
  "apitools.privatToken.held": "Token držen",
  "apitools.privatToken.none": "Žádný token",
  "apitools.privatToken.autoLoginOff": "Auto-login vypnutý",
  "apitools.privatToken.obtain": "Získat token",
  "apitools.privatToken.refresh": "Získat znovu",
  "apitools.privatToken.discard": "Zahodit",
  "apitools.privatToken.obtainedAt": "Získán",
  "apitools.privatToken.validUntil": "Platí do",
  "apitools.privatToken.remaining": "zbývá {{seconds}} s",
  "apitools.privatToken.source": "Zdroj",
  "apitools.privatToken.estimated": "Platnost je odhad Test Token Serveru — Privat Mobile API dobu platnosti ani refresh token nevrací. Token může přestat platit dřív; po odmítnutí (401) se získá znovu.",
  "apitools.privatToken.failed": "Přihlášení selhalo v kroku „{{step}}\"",
  "apitools.pending.title": "Čekající transakce ({{count}})",
  "apitools.pending.hint": "Vyčteno operací Čekající transakce. Tlačítka přepnou na příslušnou záložku a předvyplní parametry — odeslat je musíš tam, takže jde ještě upravit volba hesla i režim.",
  "apitools.pending.refresh": "Obnovit",
  "apitools.pending.refreshFailed": "Obnovení fronty selhalo",
  "apitools.pending.expiresAt": "Vyprší",
  "apitools.pending.message": "Zpráva",
  "apitools.pending.detail": "Detail",
  "apitools.pending.approve": "Schválit",
  "apitools.pending.reject": "Zamítnout",
  "apitools.pending.noMessage": "Transakce nenese zprávu k podpisu, schválit ji nelze. Zkus výpis znovu se zapnutou volbou Zahrnout detaily.",
  "kbcaasauth.title": "KB CAAS autorizační workflow",
  "kbcaasauth.run": "Spustit",
  "kbcaasauth.copyToTx": "Kopírovat do Authorize Transaction →",
  "kbcaasauth.continuation": "Pokračování (continuation)",
  "kbcaasauth.continue": "Pokračovat",
  "kbcaasauth.cancel": "Zrušit session",
  "kbcaasauth.cancelConfirm": "Opravdu zrušit?",
  "kbcaasauth.rosResult": "Výsledek ROS",
  "kbcaasauth.retriesLeft": "Zbývá pokusů",
  "kbcaasauth.expiresAt": "Vyprší",
  "kbcaasauth.recoveryHint": "Náprava",
  "kbcaasauth.canRetry": "Lze opakovat",
  "kbcaasauth.wf.activate": "Activate by KBK",
  "kbcaasauth.wf.login": "Login",
  "kbcaasauth.wf.ros": "Register ROS",
  "kbcaasauth.wf.authorize": "Authorize Transaction",
  "kbcaasauth.wf.sessions": "Sessions",
  "kbcaasauth.f.kbkToken": "KBK Token",
  "kbcaasauth.f.pinType": "Typ PINu",
  "kbcaasauth.f.language": "Jazyk",
  "kbcaasauth.f.note": "Poznámka (volitelné)",
  "kbcaasauth.f.authSubject": "Auth Subject (KBID owner ident)",
  "kbcaasauth.f.msgToAuthData": "Data k podpisu — msgToAuth.data (JSON)",
  "kbcaasauth.f.scoringData": "Scoring data (JSON, volitelné)",
  "kbcaasauth.f.paatToken": "PAAT Token",
  "kbcaasauth.f.requestUri": "request_uri (z Register ROS)",
  "kbcaasauth.f.kbSessionId": "X-KB-Session-Id (z Register ROS)",
  "kbcaasauth.f.sessionId": "Session ID",
  "kbcaasauth.f.otp": "OTP",
  "kbcaasauth.f.oidcUrl": "OIDC result URL",
  "kbcaasauth.sessions.load": "Načíst sessions",
  "kbcaasauth.sessions.sessionId": "Session ID",
  "kbcaasauth.sessions.workflow": "Workflow",
  "kbcaasauth.sessions.status": "Stav",
  "kbcaasauth.sessions.template": "Šablona",
  "kbcaasauth.sessions.lastStep": "Poslední krok",
  "kbcaasauth.sessions.use": "Použít",
  "kbcaasauth.sessions.empty": "Žádné sessions",
  "echtools.nav": "eChannels Tools",
  "echtools.title": "eChannels Tools",
  "echtools.subtitle": "CSOB eChannels API konzole (21 operací + OAuth2)",
  "echtools.noConnector": "eChannels konektor není v tomto buildu dostupný.",
  "echtools.baseUrl": "Base URL",
  "echtools.execute": "Spustit operaci",
  "echtools.genUuid": "Generovat UUID",
  "echtools.copy": "Kopírovat",
  "echtools.selectTransaction": "-- Vyberte transakci --",
  "echtools.cacheToken": "Token z cache",
  "echtools.err.noCacheToken": "Nejprve načtěte transakce (Seznam autorizací) — chybí token z cache.",
  "echtools.signature": "Podpis",
  "echtools.oauth.title": "OAuth2 token",
  "echtools.oauth.subject": "Subject (ID uživatele)",
  "echtools.oauth.subject.hint": "Posílá se u každé operace",
  "echtools.oauth.clientId": "Client ID",
  "echtools.oauth.scope": "Scope",
  "echtools.oauth.scope.hint": "Aktivace / Podpis",
  "echtools.oauth.scope.activation": "Aktivace",
  "echtools.oauth.scope.signing": "Podpis",
  "echtools.oauth.override": "Access token override",
  "echtools.oauth.override.hint": "Nastaveno → obejde OAuth2 (Bearer)",
  "echtools.oauth.getToken": "Získat access token",
  "echtools.oauth.expiresIn": "Vyprší za",
  "echtools.group.activation": "Aktivace",
  "echtools.group.authorization": "Autorizace",
  "echtools.group.otp": "OTP",
  "echtools.group.profile": "Profil / IPPID",
  "echtools.group.deviceReplacement": "Výměna zařízení",
  "echtools.group.transaction": "Transakce",
  "echtools.group.displayPin": "Display PIN",
  "echtools.op.initActivation": "Init aktivace",
  "echtools.op.getInstanceInfo": "Info o instanci",
  "echtools.op.finishActivation": "Dokončit aktivaci",
  "echtools.op.processActivation": "Zpracovat aktivaci",
  "echtools.op.createAuthRequest": "Vytvořit autorizaci",
  "echtools.op.confirmAuthRequest": "Potvrdit autorizaci",
  "echtools.op.getAuthDetail": "Detail autorizace",
  "echtools.op.getAuthDetailPost": "Detail autorizace (POST)",
  "echtools.op.getAuthList": "Seznam autorizací",
  "echtools.op.receiveElbCache": "Receive ELB Cache",
  "echtools.op.receiveAuthStatus": "Receive Auth Status",
  "echtools.op.rejectAuthRequest": "Zamítnout autorizaci",
  "echtools.op.setOfflineStatus": "Nastavit offline stav",
  "echtools.op.verifyOtp": "Ověřit OTP",
  "echtools.op.validateOtp": "Validovat OTP",
  "echtools.op.addIppid": "Přidat IPPID",
  "echtools.op.removeIppid": "Odebrat IPPID",
  "echtools.op.createReplacement": "Vytvořit výměnu zařízení",
  "echtools.op.processReplacement": "Zpracovat výměnu zařízení",
  "echtools.op.confirmTransaction": "Potvrdit transakci",
  "echtools.op.displayPinToken": "Display PIN Token",
  "echtools.f.activationOtp": "Aktivační OTP",
  "echtools.f.activationGuid": "Aktivační GUID",
  "echtools.f.instanceId": "Instance ID",
  "echtools.f.reason": "Důvod",
  "echtools.f.tokenId": "Token",
  "echtools.f.mobileSDKData": "Mobile SDK Data",
  "echtools.f.isMigration": "Migrace",
  "echtools.f.message": "Zpráva (base64)",
  "echtools.f.applicationId": "Application ID",
  "echtools.f.pushIdentifier": "Push Identifier",
  "echtools.f.processGuid": "Process GUID",
  "echtools.f.signId": "Sign ID",
  "echtools.f.transactionId": "Transaction ID",
  "echtools.f.requestTypeId": "Request Type ID",
  "echtools.f.device": "Zařízení",
  "echtools.f.secureChannelMessageSignature": "Secure Channel Message Signature",
  "echtools.f.guid": "GUID",
  "echtools.f.pinType": "Typ PINu",
  "echtools.f.usedDeviceAuthType": "Used Device Auth Type",
  "echtools.f.deviceType": "Device Type",
  "echtools.f.ippids": "IPPID (oddělené čárkou)",
  "echtools.f.deviceId": "Device ID",
  "echtools.f.otp": "OTP",
  "echtools.f.password": "Heslo",
  "echtools.f.requestStatusId": "Request Status ID",
  "echtools.f.errorCode": "Kód chyby",
  "echtools.f.newIppidIdToken": "New IPPID ID Token",
  "echtools.f.mobileSdkData": "Mobile SDK Data",
  "echtools.f.request": "Request (šifrovaný)",
  "echtools.f.identitiesToRemove": "Identity k odebrání (čárkou)",
  "echtools.f.operationId": "Operation ID",
  "echtools.f.signature": "Podpis",
  "echtools.f.additionalData": "Additional Data",
  "echtools.cache.title": "Cache transakcí",
  "echtools.cache.allStatuses": "Všechny stavy",
  "echtools.cache.allTypes": "Všechny typy",
  "echtools.cache.type": "Typ",
  "echtools.cache.status": "Stav",
  "echtools.cache.expiration": "Expirace",
  "echtools.cache.detail": "Detail",
  "echtools.cache.loaded": "Načteno",
  "echtools.cache.notLoaded": "Nenačteno",
  "echtools.cache.fetchDetail": "Načíst detail",
  "echtools.cache.confirmValid": "Potvrdit (valid)",
  "echtools.cache.confirmInvalid": "Potvrdit (invalid)",
  "echtools.cache.reject": "Zamítnout",
  "asymtools.nav": "Asym requesty",
  "asymtools.title": "Asym requesty",
  "asymtools.subtitle": "Vydá podepsaný request, podpis zprávy nebo obojí najednou — odeslání na auth server je na vás",
  "asymtools.token": "Token",
  "asymtools.tokenPlaceholder": "Vyberte nebo zadejte Token ID",
  "asymtools.operation": "Operace",
  "asymtools.operationId": "ID operace",
  "asymtools.operationIdHint": "Identifikátor z předchozího kroku výměny zařízení.",
  "asymtools.build": "Vygenerovat request",
  "asymtools.running": "Generuji…",
  "asymtools.notSentHint": "Server request pouze sestavil. Odeslat na auth server si ho musíte sami.",
  "asymtools.copy": "Kopírovat",
  "asymtools.copied": "Zkopírováno",
  "asymtools.group.tx": "Transakce",
  "asymtools.group.token": "Token a instance",
  "asymtools.group.dr": "Výměna zařízení",
  "asymtools.group.auth": "Přihlášení",
  "asymtools.op.getPendingTransactions": "Čekající transakce",
  "asymtools.op.getInstanceInfo": "Informace o instanci",
  "asymtools.op.approveTransaction": "Schválení transakce",
  "asymtools.op.rejectTransaction": "Zamítnutí transakce",
  "asymtools.op.deactivate": "Deaktivace instance",
  "asymtools.op.createDeviceReplacement": "Založení výměny zařízení",
  "asymtools.op.processDeviceReplacement": "Dokončení výměny zařízení",
  "asymtools.op.login": "Přihlášení",
  "asymtools.sign.message": "Zpráva od auth serveru",
  "asymtools.sign.messageHint": "Base64 zašifrovaná zpráva — secureChannelMessage transakce nebo challenge z přihlášení.",
  "asymtools.sign.scoringFlags": "Scoring flags",
  "asymtools.sign.submit": "Podepsat",
  "asymtools.sign.decrypt": "Dešifrovat",
  "asymtools.tool": "Nástroj",
  "asymtools.tool.request": "Obálka requestu",
  "asymtools.tool.request.hint": "Vygeneruje podepsanou obálku, kterou by token poslal auth serveru. U schválení transakce a druhého kroku přihlášení obálka sama nestačí — použijte Obálku s podpisem.",
  "asymtools.tool.approve": "Obálka s podpisem",
  "asymtools.tool.approve.hint": "Protějšek metody SDK createApproveTransactionRequest: obálka, podpis i additionalData jedním voláním. Použijte pro schválení transakce, druhý krok přihlášení i autorizaci platby.",
  "asymtools.tool.approve.submit": "Vygenerovat a podepsat",
  "asymtools.tool.signature": "Jen podpis",
  "asymtools.tool.signature.hint": "Podepíše zprávu od auth serveru a vrátí podpis s odpovídajícím additionalData. Obálku si vezměte z nástroje Obálka requestu.",
  "asymtools.tool.decrypt": "Dešifrování",
  "asymtools.tool.decrypt.hint": "Ukáže obsah zprávy od auth serveru, tedy co se vlastně podepisuje.",
  "asymtools.sign.scoringFlagsHint": "Bit 0 = rooted, bit 1 = biometrika. Má přednost před typem ověření.",
  "asymtools.sign.recognitionType": "Typ ověření",
  "asymtools.sign.recognitionTypeHint": "Použije se, jen když scoring flags necháte prázdné. Pozor: SDK čísluje jinak (None 0 / Password 1 / Biometric 2).",
  "asymtools.sign.recognitionType.unset": "Neuvádět",
  "asymtools.sign.recognitionType.password": "0 — heslo",
  "asymtools.sign.recognitionType.biometrics": "1 — biometrika",
  "asymtools.sign.password": "Heslo",
  "asymtools.sign.passwordValid": "Platné",
  "asymtools.sign.passwordInvalid": "Záměrně chybné",
  "asymtools.sign.userPassword": "Heslo (override)",
  "asymtools.sign.userPasswordHint": "Nepovinné. Prázdné = použije se heslo uložené u tokenu. Při záměrně chybném heslu se ignoruje, proto se pole nenabízí.",
  "asymtools.warning": "Upozornění",
  "asymtools.nextCall": "Kam to patří na drátě",
  "asymtools.nextCall.query": "Parametry dotazu",
  "asymtools.nextCall.body": "Tělo požadavku",
  "asymtools.nextCall.alternatives": "Tytéž hodnoty patří i sem",
  "soaptools.nav": "SOAP Tools",
  "soaptools.title": "SOAP Tools",
  "soaptools.subtitle": "eCobra SOAP operace s náhledem XML požadavku",
  "soaptools.endpoint": "Endpoint",
  "soaptools.noConnector": "SOAP konektor není v tomto buildu dostupný.",
  "soaptools.health.checking": "Kontroluji…",
  "soaptools.health.healthy": "Připojeno",
  "soaptools.health.unhealthy": "Nedostupné",
  "soaptools.health.refresh": "Obnovit stav",
  "soaptools.execute": "Spustit SOAP požadavek",
  "soaptools.executeHint": "Vyplňte parametry a spusťte operaci.",
  "soaptools.requestXml": "XML požadavku",
  "soaptools.response": "Odpověď",
  "soaptools.opt.yes": "Ano",
  "soaptools.opt.no": "Ne",
  "soaptools.group.otp": "Správa OTP",
  "soaptools.group.device": "Správa zařízení",
  "soaptools.group.sms": "Správa SMS",
  "soaptools.group.authorization": "Autorizace",
  "soaptools.op.generateOtp": "Generovat OTP",
  "soaptools.op.getUserOtp": "Získat OTP uživatele",
  "soaptools.op.getInstanceInfo": "Info o instanci",
  "soaptools.op.getUserDeviceList": "Seznam zařízení uživatele",
  "soaptools.op.getUserSmsPhoneNumber": "Získat telefon pro SMS",
  "soaptools.op.setUserSmsPhoneNumber": "Nastavit telefon pro SMS",
  "soaptools.op.decryptSecureMessages": "Dešifrovat Secure Messages",
  "soaptools.op.authorizationChallenge": "Autorizace — Challenge",
  "soaptools.op.authorizationProcess": "Autorizace — Process",
  "soaptools.f.identity": "Identita",
  "soaptools.f.deviceOSType": "OS zařízení",
  "soaptools.f.reason": "Důvod",
  "soaptools.f.sendSms": "Poslat SMS",
  "soaptools.f.device": "ID zařízení",
  "soaptools.f.deviceType": "Typ zařízení",
  "soaptools.f.appVersionCode": "Verze aplikace",
  "soaptools.f.identities": "Identity (oddělené čárkou)",
  "soaptools.f.filterStatus": "Filtr stavu (volitelné)",
  "soaptools.f.smsPhoneNumber": "Telefonní číslo",
  "soaptools.f.secureChannelMessage": "Secure Channel zpráva (Base64)",
  "soaptools.f.operationType": "Typ operace",
  "soaptools.f.hash": "Hash",
  "soaptools.f.title": "Titulek",
  "soaptools.f.signedDataFields": "Signed Data pole (čárkou)",
  "soaptools.f.signedDataLabels": "Signed Data popisky (čárkou)",
  "soaptools.f.signId": "Sign ID",
  "soaptools.f.signature": "Podpis (MAC kód)",
  "soaptools.f.signatureType": "Typ podpisu",
  "loadtest.nav": "Loadtest generator",
  "loadtest.title": "Load Test Generator",
  "loadtest.subtitle": "Vygeneruje ZIP bundle (JMeter plán + identity + warmup)",
  "loadtest.section.scenario": "Scénář",
  "loadtest.section.identities": "Identity",
  "loadtest.section.load": "Zátěž a cíl",
  "loadtest.section.warmup": "Warmup",
  "loadtest.warmup.unavailable": "V tomto buildu není dostupný žádný warm-up provider — vygenerovaný plán nepůjde spustit (warm-up vyžaduje eCobra SOAP konektor).",
  "loadtest.warmup.available": "Warm-up dostupný pro: {{types}}",
  "loadtest.section.apiKey": "API klíč",
  "loadtest.targetSystem": "Cílový systém",
  "loadtest.scenario": "Scénář",
  "loadtest.warmupMode": "Režim warmup",
  "loadtest.warmup.runtime": "Runtime (čerstvé OTP na iteraci)",
  "loadtest.warmup.pregenerated": "Pre-generated (zapéct OTP do CSV nyní)",
  "loadtest.source.list": "Seznam (CSV)",
  "loadtest.source.pattern": "Vzor",
  "loadtest.identitiesCsv": "Identity (CSV)",
  "loadtest.identitiesCsv.hint": "Jeden řádek na identitu",
  "loadtest.usernamePrefix": "Prefix jména",
  "loadtest.startIndex": "Start index",
  "loadtest.endIndex": "End index",
  "loadtest.padWidth": "Pad width",
  "loadtest.phonePattern": "Vzor telefonu",
  "loadtest.password": "Heslo",
  "loadtest.paatProfile": "PAAT profil",
  "loadtest.threads": "Vlákna",
  "loadtest.rampUp": "Ramp-up (s)",
  "loadtest.loops": "Smyčky",
  "loadtest.protocol": "Protokol",
  "loadtest.host": "Host",
  "loadtest.port": "Port",
  "loadtest.clientIdent": "Client Ident",
  "loadtest.systemId": "System ID",
  "loadtest.deviceOSType": "OS zařízení",
  "loadtest.reason": "Důvod",
  "loadtest.sendSms": "Poslat SMS",
  "loadtest.setPhone": "Nastavit telefon",
  "loadtest.embedApiKey": "Vložit API klíč do bundlu",
  "loadtest.apiKey": "API klíč",
  "loadtest.generate": "Generovat bundle",
  "loadtest.generated": "Bundle vygenerován, stahování zahájeno (etts-loadtest.zip).",
  "paat.title": "PAAT profily",
  "paat.subtitle": "Device-info profily pro eChannels aktivaci",
  "paat.add": "Přidat profil",
  "paat.bulkUpdate": "Hromadná úprava verzí",
  "paat.editTitle": "Upravit PAAT profil",
  "paat.deleteTitle": "Smazat PAAT profil",
  "paat.deleteConfirm": "Opravdu smazat profil „{{id}}\"? Nelze smazat profil používaný tokeny.",
  "paat.default": "Výchozí",
  "paat.setDefault": "Nastavit jako výchozí",
  "paat.selectPlatform": "-- Vyberte platformu --",
  "paat.fillRequired": "Vyplňte všechna povinná pole",
  "paat.versionCode": "Version code",
  "paat.apiLevel": "API level",
  "paat.language": "Jazyk",
  "paat.deviceModel": "Model zařízení",
  "paat.deviceName": "Název zařízení",
  "paat.deviceManufacturer": "Výrobce",
  "paat.bulkHint": "Aktualizuje verze u všech profilů dané platformy. Alespoň jedna verze je povinná.",
  "paat.bulkNeedVersion": "Zadejte alespoň jednu verzi",
  "paat.bulkApply": "Aplikovat",
  "paat.idPattern": "ID smí obsahovat jen písmena, číslice, pomlčku a podtržítko",
  "paat.idHint": "Písmena, číslice, pomlčka, podtržítko",
  "paat.bulkConfirm": "Potvrdit a aktualizovat",
  "paat.bulkConfirmSummary": "Aktualizovat všechny profily platformy {{platform}}?",
  "paat.col.id": "ID",
  "paat.col.name": "Název",
  "paat.col.platform": "Platforma",
  "paat.col.appVersion": "App verze",
  "paat.col.sdkVersion": "SDK verze",
  "paat.col.usage": "Použití",
  "paat.col.device": "Zařízení",
  "paat.col.versionCode": "Version code",
  "paat.col.apiLevel": "API level",
  "paat.col.default": "Výchozí",
  "tokens.col.tags": "Tagy",
  "tokens.col.paat": "PAAT profil",
  "tokens.col.actions": "Akce",
  "tokens.filter.all": "Vše",
  "tokens.filter.clear": "Vymazat filtry",
  "tokens.filter.usernamePlaceholder": "Hledat username…",
  "tokens.filter.tokenIdPlaceholder": "Hledat Token ID…",
  "tokens.filter.tagPlaceholder": "Hledat tag…",
  "tokens.results.count": "Nalezeno {{count}} tokenů",
  "tokens.results.empty": "Žádné tokeny nenalezeny.",
  "tokens.action.detail": "Otevřít detail",
  "tokens.action.copyId": "Kopírovat Token ID",
  "tokens.action.sync": "Synchronizovat stav",
  "tokens.action.tags": "Upravit tagy",
  "tokens.action.expiration": "Expirace",
  "tokens.action.paat": "Změnit PAAT profil",
  "tokens.action.blocked.deleted": "Nelze u smazaného tokenu",
  "tokens.action.blocked.notActivated": "Token zatím není aktivovaný",
  "tokens.action.blocked.notActive": "Jen u aktivního tokenu",
  "tokens.action.changePassword": "Změnit heslo",
  "tokens.action.generateOtp": "Generovat OTP",
  "tokens.pw.required": "Heslo je povinné.",
  "tokens.pw.old": "Staré heslo",
  "tokens.pw.new": "Nové heslo",
  "tokens.pw.label": "Heslo",
  "tokens.otp.expiresAt": "Vyprší",
  "tokens.field.password": "Heslo (PIN)",
  "tokens.field.pushIdentifier": "Push Identifier",
  "tokens.field.deviceFingerprint": "Device Fingerprint",
  "tokens.secrets": "Token Secrets (SDK)",
  "tokens.secret.encryptionSalt": "Encryption salt",
  "tokens.secret.passwordCommon": "Heslo (common)",
  "tokens.secret.secretPassword": "Heslo (secret)",
  "tokens.secret.asymTokenData": "AsymToken data",
  "common.close": "Zavřít",
  "tokens.action.deactivate": "Deaktivovat",
  "tokens.action.waitingForAuthServer": "Čeká se na odpověď auth serveru. Když neodpovídá, může to trvat až minutu.",
  "tokens.action.delete": "Smazat",
  "tokens.deactivateConfirm": "Opravdu deaktivovat token {{tokenId}}? Zavolá se auth server.",
  "tokens.deleteConfirm": "Opravdu trvale smazat token {{tokenId}}? Akci nelze vrátit.",
  "tokens.tagsLabel": "Tagy (oddělené čárkou)",
  "tokens.expiration.clear": "Zrušit expiraci",
  "tokens.expiration.ttlSeconds": "TTL v sekundách (volitelné)",
  "tokens.expiration.ttlHint": "Když je vyplněno, má přednost před datem — expirace = nyní + N sekund.",
  "tokens.paat.warning": "Změna PAAT profilu může změnit platformu tokenu (Android/iOS). Ujistěte se, že to odpovídá skutečnému zařízení.",
  "tokens.tab.overview": "Přehled",
  "tokens.tab.activation": "Aktivace",
  "tokens.tab.device": "Zařízení a klíče",
  "tokens.sync.changed": "Stav sesynchronizován: {{from}} → {{to}}",
  "tokens.sync.unchanged": "Stav se nezměnil ({{state}}) — auth server hlásí totéž co eTTS.",
  "tokens.sync.failed": "Synchronizace stavu selhala",
  "tokens.bulk.selected": "Vybráno {{tokens}} tokenů",
  "tokens.bulk.allMatchingSelected": "Vybráno všech {{tokens}} tokenů odpovídajících filtru",
  "tokens.bulk.selectAllMatching": "Vybrat všech {{total}} odpovídajících filtru",
  "tokens.bulk.clear": "Zrušit výběr",
  "tokens.bulk.selectPage": "Vybrat všechny na stránce",
  "tokens.bulk.selectRow": "Vybrat token {{tokenId}}",
  "tokens.bulk.scope.ids": "Vybrané tokeny: {{tokens}}",
  "tokens.bulk.scope.filter": "Všechny tokeny odpovídající filtru: {{tokens}}",
  "tokens.bulk.blockedHint": "U {{count}} z vybraných tokenů akci stav nedovolí — server je přeskočí a uvede v souhrnu.",
  "tokens.bulk.confirmUnderstand": "Rozumím, že akce se provede nad {{tokens}} tokeny a nelze ji vrátit.",
  "tokens.bulk.start": "Spustit",
  "tokens.bulk.stop": "Zastavit",
  "tokens.bulk.stopped": "Zastaveno — zpracováno {{processed}} z {{total}}. Už provedené změny zůstávají.",
  "tokens.bulk.progress": "Zpracováno {{processed}} / {{total}}",
  "tokens.bulk.summary.succeeded": "Úspěšně",
  "tokens.bulk.summary.failed": "Chyba",
  "tokens.bulk.summary.skipped": "Přeskočeno",
  "tokens.bulk.summary.skippedHint": "Přeskočené tokeny jsou ty, kterým akci nedovolil jejich stav, nebo mezitím zmizely.",
  "tokens.bulk.summary.errors": "Chyby ({{count}})",
  "tokens.bulk.summary.detailsTruncated": "Výpis je zkrácený, úplný seznam je v aplikačním logu.",
  "tokens.bulk.tagsMode": "Režim úpravy tagů",
  "tokens.bulk.tagsMode.REPLACE": "Nahradit celý seznam",
  "tokens.bulk.tagsMode.ADD": "Přidat k existujícím",
  "tokens.bulk.tagsMode.REMOVE": "Odebrat z existujících",
  "tokens.bulk.emptyTags": "Zadejte alespoň jeden tag.",
  "tokens.bulk.expirationRequired": "Zadejte datum nebo TTL, případně zaškrtněte zrušení expirace.",
  "tokens.bulk.ttlHint": "Vyhodnotí se jednou na začátku běhu — všechny tokeny dostanou stejný okamžik.",
  "tokens.bulk.deleteWarning": "Tokeny se smažou trvale, včetně klíčového materiálu. Akci nelze vrátit.",
  "tokens.bulk.deactivateWarning": "Pro každý token se volá auth server — u tisíců tokenů to může trvat minuty.",
  "tokens.bulk.bypassAuthServer": "Nevolat auth server",
  "tokens.bulk.bypassAuthServerHint": "Tokeny se označí jako smazané jen lokálně. Rychlé a funguje i při nedostupném serveru, ale stav se s ním rozejde.",
  "docs.title": "Nápověda",
  "docs.subtitle": "Dokumentace a návody k eTTS",
  "docs.search.placeholder": "Hledat v nápovědě…",
  "docs.search.noResults": "Nic nenalezeno",
  "docs.nav.toggle": "Obsah / navigace",
  "docs.toc.title": "Na této stránce",
  "docs.notFound": "Stránka nenalezena.",
  "docs.banner.notTranslated": "Tato stránka zatím nebyla přeložena — zobrazuje se česká verze.",
  "docs.switchToCzech": "Přepnout do češtiny",
  "docs.locked.title": "Funkce není u vaší licence aktivní.",
  "common.edit": "Upravit",
  "locale.label": "Jazyk",
  "locale.title": "Jazyk rozhraní",
  "locale.subtitle": "Volba se uloží k vašemu účtu a použije se i pro texty ze serveru.",
  "locale.cs": "Čeština",
  "locale.sk": "Slovenčina",
  "locale.en": "English",
  "locale.cs.short": "CS",
  "locale.sk.short": "SK",
  "locale.en.short": "EN",
  "locale.saveError": "Jazyk se nepodařilo uložit. Zkuste to znovu.",
  "feature.advertised.badge": "Brzy k dispozici",
  "feature.locked.badge": "Zamčeno",
  "feature.advertised.title": "Brzy k dispozici",
  "feature.advertised.default": "Tato funkce je ve vývoji a bude k dispozici v některém z dalších releasů.",
  "feature.locked.title": "Funkce není ve vaší licenci",
  "feature.locked.detail": "Tato funkce není ve vaší licenční úrovni aktivována. Kontaktujte správce licencí nebo upgradujte, abyste ji odemkli.",
  "feature.plannedFor": "Plánováno pro verzi {{version}}",
  "feature.viewLicense": "Zobrazit licenci",
  "feature.id": "Identifikátor funkce",
  "feature.hidden.title": "Stránka není dostupná",
  "feature.hidden.detail": "Tato část administrace není v této instalaci k dispozici.",
  "feature.backHome": "Zpět na přehled",
  "general.version": "Verze aplikace",
  "settings.notifications": "Oznámení",
  "notifications.markAllRead": "Označit vše jako přečtené",
  "notifications.markRead": "Označit jako přečtené",
  "notifications.viewAll": "Zobrazit všechna oznámení",
  "notifications.unread": "Nepřečteno",
  "notifications.unreadOnly": "Jen nepřečtená",
  "notifications.lastSeen": "naposledy",
  "notifications.severity.INFO": "Informace",
  "notifications.severity.WARNING": "Varování",
  "notifications.severity.ERROR": "Chyba",
  "notifications.category.APPLICATION_ERROR": "Chyby aplikace",
  "notifications.category.APPLICATION_ERROR.desc": "Neočekávaná selhání — výjimky, nedostupná infrastruktura, chyby plánovače. Zamítnutí ze strany auth serveru sem nepatří: to je legitimní výsledek testu.",
  "notifications.category.MAINTENANCE": "Údržba",
  "notifications.category.MAINTENANCE.desc": "Dokončený úklid, záloha databáze, deaktivace expirovaných tokenů.",
  "notifications.category.SECURITY": "Bezpečnost",
  "notifications.category.SECURITY.desc": "Zámek účtu, neúspěšná přihlášení, změna rolí, nedostupný adresář.",
  "notifications.category.EXPIRY": "Expirace",
  "notifications.category.EXPIRY.desc": "Blížící se konec platnosti licence, TLS certifikátu a tokenů s TTL.",
  "notifications.type.APPLICATION_ERROR_LOGGED.title": "Chyba aplikace v {{logger}}",
  "notifications.type.APPLICATION_ERROR_LOGGED.message": "{{detail}}",
  "notifications.type.MAINTENANCE_AUTO_CLEANUP_COMPLETED.title": "Automatický úklid dokončen",
  "notifications.type.MAINTENANCE_AUTO_CLEANUP_COMPLETED.message": "Smazáno {{httpLogs}} komunikačních logů, {{transactionLogs}} transakčních logů a {{activationEvents}} aktivačních událostí ({{durationMs}} ms).",
  "notifications.type.MAINTENANCE_CLEANUP_COMPLETED.title": "Úklid dokončen",
  "notifications.type.MAINTENANCE_CLEANUP_COMPLETED.message": "Smazáno {{deleted}} záznamů.",
  "notifications.type.MAINTENANCE_BACKUP_COMPLETED.title": "Záloha databáze dokončena",
  "notifications.type.MAINTENANCE_BACKUP_COMPLETED.message": "{{filename}} ({{size}}), {{durationMs}} ms.",
  "notifications.type.MAINTENANCE_TOKENS_EXPIRED.title": "Expirované tokeny deaktivovány",
  "notifications.type.MAINTENANCE_TOKENS_EXPIRED.message": "Deaktivováno {{count}} tokenů ({{durationMs}} ms).",
  "notifications.type.SECURITY_ACCOUNT_LOCKED.title": "Účet {{username}} byl uzamčen",
  "notifications.type.SECURITY_ACCOUNT_LOCKED.message": "Uzamčeno po opakovaných neúspěšných přihlášeních.",
  "notifications.type.SECURITY_LOGIN_FAILED.title": "Neúspěšné přihlášení: {{username}}",
  "notifications.type.SECURITY_LOGIN_FAILED.message": "",
  "notifications.type.SECURITY_ROLES_CHANGED.title": "Změna rolí uživatele {{username}}",
  "notifications.type.SECURITY_ROLES_CHANGED.message": "Nové role: {{roles}} (změnil {{actor}}).",
  "notifications.type.SECURITY_DIRECTORY_DOWN.title": "Adresářová služba nedostupná",
  "notifications.type.SECURITY_DIRECTORY_DOWN.message": "Přihlášení proti adresáři neprošlo — ověřte konektivitu.",
  "notifications.type.EXPIRY_LICENSE.title": "Licenci vyprší platnost za {{days}} dní",
  "notifications.type.EXPIRY_LICENSE.message": "Platnost do {{validTo}}.",
  "notifications.type.EXPIRY_TLS_CERTIFICATE.title": "TLS certifikátu vyprší platnost za {{days}} dní",
  "notifications.type.EXPIRY_TLS_CERTIFICATE.message": "Platnost do {{notAfter}}.",
  "notifications.type.EXPIRY_TOKENS.title": "{{count}} tokenům vyprší platnost do {{days}} dní",
  "notifications.type.EXPIRY_TOKENS.message": "",
  "notificationSettings.title": "Oznámení",
  "notificationSettings.subtitle": "Co kanál eskaluje, jak dlouho se oznámení drží a co bylo doručeno.",
  "notificationSettings.categories": "Kategorie",
  "notificationSettings.categoriesHint": "Vypnutá kategorie se nezakládá vůbec. Minimální závažnost odfiltruje méně důležité události v rámci kategorie.",
  "notificationSettings.minSeverity": "Minimální závažnost",
  "notificationSettings.retentionDays": "Retence (dny)",
  "notificationSettings.retentionHint": "Starší oznámení se mažou při hodinovém úklidu.",
  "notificationSettings.dedupWindow": "Okno slučování (minuty)",
  "notificationSettings.dedupHint": "Táž událost v okně jen zvedne počítadlo místo nového řádku.",
  "notificationSettings.reset": "Vrátit výchozí",
  "common.saved": "Uloženo",
  "notifications.unreadCount": "Oznámení — {{count}} nepřečtených",
  "notifications.category.TEST": "Testovací",
  "notifications.category.TEST.desc": "Ručně vyvolaná oznámení pro ověření, že kanál a zvoneček fungují.",
  "notifications.type.TEST_NOTIFICATION.title": "Testovací oznámení ({{severity}})",
  "notifications.type.TEST_NOTIFICATION.message": "Vyvoláno ručně z Nastavení → Oznámení. Slouží jen k ověření kanálu.",
  "notificationSettings.testTitle": "Ověření kanálu",
  "notificationSettings.testHint": "Vytvoří testovací oznámení, na kterém si zkontrolujete zvoneček, barvy závažností i doručení — bez čekání na skutečnou událost.",
  "notificationSettings.createTest": "Vytvořit testovací oznámení",
  "notificationSettings.testCreated": "Vytvořeno — podívejte se na zvoneček",
  "versionNotice.title": "Aplikace byla aktualizována na {{version}}",
  "versionNotice.subtitle": "Naposledy jste pracovali s verzí {{previous}}. Tady je, co je nového.",
  "versionNotice.viewAll": "Zobrazit všechny změny",
  "versionNotice.dismiss": "Rozumím",
  "versionNotice.noChangelog": "K této verzi zatím není záznam v přehledu změn. Celý přehled najdete v nápovědě.",
  "notifications.type.APP_VERSION_UPDATED.title": "Aplikace aktualizována na {{version}}",
  "notifications.type.APP_VERSION_UPDATED.message": "Předchozí verze: {{previousVersion}}. Přehled změn najdete v nápovědě.",
  "scenarios.nav": "Scénáře",
  "scenarios.title": "Generátor scénářů",
  "scenarios.subtitle": "Deklarativní scénáře — spusť je živě v ETTS, nebo vyexportuj pro JMeter, SoapUI, Postman či k6.",
  "scenarios.catalog": "Katalog",
  "scenarios.pickOne": "Vyber scénář ze seznamu vlevo.",
  "scenarios.steps": "{{count}} kroků",
  "scenarios.system": "Výstupní systém",
  "scenarios.mode": "Režim",
  "scenarios.export": "Stáhnout artefakty",
  "scenarios.exported": "Artefakty staženy.",
  "scenarios.run": "Spustit v ETTS",
  "scenarios.notLoadSafe": "jen funkční",
  "scenarios.documentProblems": "Některé dokumenty se nepodařilo přečíst:",
  "scenarios.keyTtl": "Platnost klíče",
  "scenarios.issueKey": "Vystavit API klíč",
  "scenarios.keyIssued": "Klíč vystaven s oprávněními {{scopes}}, platí do {{expires}}. Zobrazuje se jen teď.",
  "scenarios.keyUnresolved": "U kroků {{steps}} se oprávnění nepodařilo určit — klíč na ně nemusí stačit.",
  "perfMode.title": "Režim Performance",
  "perfMode.subtitle": "Dočasně omezí zápis komunikačních logů, aby zátěžový test nezaplnil databázi.",
  "perfMode.activeTitle": "Režim Performance běží",
  "perfMode.activeDetail": "Komunikační logy jsou omezené na úroveň {{level}}.",
  "perfMode.levelLabel": "Rozsah logování",
  "perfMode.durationLabel": "Na jak dlouho",
  "perfMode.minutes": "{{count}} min",
  "perfMode.start": "Zapnout režim",
  "perfMode.stop": "Vypnout režim",
  "perfMode.remaining": "Zbývá",
  "perfMode.startedBy": "Zapnul",
  "perfMode.suppressed": "Potlačených oznámení",
  "perfMode.goToStats": "Statistiky serveru",
  "perfMode.goToStatsAfterStart": "Po zapnutí přejít na statistiky serveru",
  "perfMode.autoExpiryHint": "Režim vždy skončí sám. Nejdéle může běžet 8 hodin.",
  "perfMode.queueHint": "Řádky zapsané před zapnutím se ještě chvíli dokládají z fronty.",
  "perfMode.level.FULL": "Plné logování",
  "perfMode.level.NO_BODIES": "Bez těl zpráv",
  "perfMode.level.ERRORS_ONLY": "Jen chyby",
  "perfMode.level.OFF": "Vypnuto",
  "perfMode.levelHint.FULL": "Zapisuje se vše včetně těl zpráv.",
  "perfMode.levelHint.NO_BODIES": "Řádek zůstane, zmizí jen těla a hlavičky — ta objemná část.",
  "perfMode.levelHint.ERRORS_ONLY": "Doporučeno. Uloží se jen neúspěšná volání, zato celá.",
  "perfMode.levelHint.OFF": "Nezapisuje se nic. Po selhaném testu nezbude žádná stopa.",
  "perfMode.logsBanner": "Režim Performance běží — komunikační logy se teď zapisují omezeně ({{level}}).",
  "perfMode.statsBanner": "Režim Performance běží. Zbývá {{remaining}}.",
  "perfMode.faster": "Obnovovat po 2 s",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_STARTED.title": "Zapnut režim Performance",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_STARTED.message": "Komunikační logy jsou omezené ({{level}}) na {{minutes}} min. Zapnul: {{actor}}.",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_ENDED.title": "Režim Performance skončil",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_ENDED.message": "Komunikační logy se zase zapisují v plném rozsahu. Běžel {{minutes}} min, potlačeno {{suppressed}} oznámení.",
  "perfMode.sinceHint": "Běží od {{since}} — starší řádky vznikly ještě před zapnutím.",
  "perfMode.startedAt": "Běží od",
  "perfMode.tooltipActive": "Komunikační logy: {{level}}. Běží od {{since}}."
}
